export default __webpack_public_path__ + "static/media/cookie_background_left.826b6f63.png";